import React from 'react'

const avatars = {
  Pascal: require('../main/avatar-1.svg'),
  Beat: require('../main/avatar-2.svg'),
  Dummy: require('../main/avatar-3.svg'),
  Silvan: require('../main/avatar-4.svg'),
  Nino: require('../main/avatar-5.svg'),
  Nicolas: require('../main/avatar-6.svg'),
  Annabelle: require('../main/avatar-7.svg'),
  Anouk: require('../main/avatar-8.svg'),
  Ivana: require('../main/avatar-9.svg'),
  Lisa: require('../main/avatar-10.svg'),
  Rahel: require('../main/avatar-11.svg'),
  Zoé: require('../main/avatar-12.svg')
}

export default function answer(props) {
  return (
    <div className='item answer'>
      <img className='ui avatar image' src={avatars[props.who]} />
      <div className='content'>
        <div className='header'>{props.who}</div>
        <div className='description'>{props.children}</div>
      </div>
    </div>
  )
}

answer.propTypes = {
  // who: React.PropTypes.oneOf(['Annabelle', 'Anouk', 'Ivana', 'Lisa', 'Rahel', 'Zoé', 'Pascal', 'Beat', 'Silvan', 'Nino', 'Nicolas']).isRequired,
  // children: React.PropTypes.node
}
